/* unplugin-vue-components disabled */import script from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"

import "./TodoManagement.vue?vue&type=style&index=0&id=5ad87744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad87744"]])

export default __exports__